module.exports = __webpack_public_path__ + "img/icon_add_new@2x.6e563504.png";